import http from 'lib/http';

/* 学员角色 */
export const utStudent = 1;
/* 讲师角色 */
export const utTeacher = 2;
/* 站点角色 */
export const utMSite = 3;
/* 系统管理员角色 */
export const utMSystem = 5;
/* 学校管理员 */
export const utMSchool = 11;

export const utEJSystem = 15;

/**
 * 根据用户类型跳转到对应路由
 *
 * @export
 * @param {number} userType
 * @returns
 */
export function redirect (userType) {
  // utStudent 学员
  // utTeacher 讲师
  // utMSchool 学校管理员
  // utMSystem 系统管理员
  // utPartner 合作伙伴
  // 学校管理员和合作伙伴的基本信息管理相同
  if (userType === utStudent) {
    return { name: 'stuManager' };
  } else if (userType === utTeacher) {
    return { name: 'teaManager' };
  } else if (userType === utMSite) {
    return { name: 'siteManager' };
  } else if (userType === utMSystem) {
    return { name: 'administration' };
  } else if (userType === utMSchool) {
    return { name: 'itcIndex' };
  } else {
    return { name: 'index' };
  }
}

/**
 * 短信验证码
 */
 export const urlsendCode = '/XOrg/AOrgInfo/sendCode';
 export interface IsendCode {
  code: number;
  msg: string;
  verifyCode: string;
}
 export function sendCode (verifyInfo: string, str: string, str1: string) {
  return http.post<IsendCode>(urlsendCode, {
    verifyInfo,
    str,
    str1
  });
}